/* eslint-disable check-file/filename-naming-convention */
import 'animate.css/animate.min.css';
import { Analytics as DubAnalytics } from '@dub/analytics/react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import 'react-toastify/dist/ReactToastify.css';
import App from '@root/src/App';

import './style.css';

import '@root/src/translations/initTranslations';
import '@root/src/utils/sentry/initSentry';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
    <DubAnalytics
      domainsConfig={{
        refer: 'ref.cropink.com',
      }}
    />
  </StrictMode>,
);
